import { render, staticRenderFns } from "./SendMessageWaiterSelectModal.vue?vue&type=template&id=208e5014&lang=pug"
import script from "./SendMessageWaiterSelectModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageWaiterSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageWaiterSelectModal.vue?vue&type=style&index=0&id=208e5014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports